import { useUpdateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { EditModalRHF } from '../../Shared/EditModalRHF';

const { NAME, API_KEY, EDIT_API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const SendgridEditModal = () => {
  const { updateAccount } = useUpdateAccount();

  return (
    <EditModalRHF onSubmit={updateAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      <ClearableConnectedInputField
        name={API_KEY}
        data-test="apiKey-input"
        labelText="API key"
        wasEditedFieldName={EDIT_API_KEY}
      />
    </EditModalRHF>
  );
};
